import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsTooltipModule } from '@cmps/ng-uikit';

import { CmpsScorecardPillarInformationComponent } from './scorecard-pillar-information.component';

@NgModule({
    declarations: [CmpsScorecardPillarInformationComponent],
    imports: [CmpsTooltipModule, CommonModule],
    exports: [CmpsScorecardPillarInformationComponent],
})
export class CmpsScorecardPillarInformationModule {}
